import { Finanzmanager } from '@/application/router/types/types';
import type { RouteRecordRaw } from 'vue-router';
import MainLayout from "@/application/layouts/MainLayout.vue";
import HandlungenPage from '@/handlungen/pages/HandlungenPage.vue';
import HandlungDetailPage from '@/handlungen/pages/HandlungDetailPage.vue';

export const handlungenRoutes: RouteRecordRaw[] = [
  {
    path: '/handlungen',
    component: MainLayout,
    children: [
      {
        path: '',
        name: Finanzmanager.HANDLUNGEN,
        component: HandlungenPage,
        meta: {
          title: 'Inbox',
        },
      },
      {
        path: ':id',
        name: Finanzmanager.HANDLUNG,
        component: HandlungDetailPage,
        props: (route) => ({ id: Number(route.params.id) }),
        meta: {
          title: 'Offene Handlung',
        },
      }
    ],
  }
]
